import React from "react";
import { NakiNigunHomeCategoryTemplate } from "themes/application/naki-nigun/components";

function NakiNigunHomeCategory(props) {
    return <NakiNigunHomeCategoryTemplate {...props} />;
}

export default NakiNigunHomeCategory;
